import React from "react";
import "./Menu.css";

const menu = {
  breakfast: [
    {
      name: "Ruga’s Big Breakfast",
      desc:
        "Barossa free range eggs, bacon, chorizo, hash brown, grilled mushrooms, grilled tomato & ciabatta toast",
      price: 26.9
    },
    {
      name: "Eggs Your Way",
      desc:
        "Barossa free range eggs, poached, sunny side up or scrambled, with ciabatta toast",
      price: 13.9
    },
    {
      name: "The Australian Omelette",
      desc: "Ham, cheese, tomato & onion",
      price: 17.9
    },
    {
      name: "The Italian Omelette",
      desc: "Salami, sun-dried tomatoes, onion & spinach",
      price: 17.9
    },
    {
      name: "The Vego Omelette",
      desc: "Tomato, mushroom, spinach & cheese",
      price: 17.9
    },
    {
      name: "Chilli Scrambled Eggs",
      desc:
        "Cajun, bacon, sweet chilli sauce, delicious mix through, on toasted Turkish",
      price: 18.9
    },
    {
      name: "Ruga’s Smashed Avo",
      desc:
        "Ciabatta toast with smashed avocado, whipped feta & balsamic glaze",
      note: "Add poached egg $3.50",
      price: 15.9
    },
    {
      name: "Brekky Wrap",
      desc:
        "Bacon, egg, Old English cheese, jalapeños, hash brown, spinach, avocado & peri peri mayo",
      price: 15.9
    },
    {
      name: "Ruga’s BS Roll",
      desc:
        "Bacon, egg, Old English cheese, grilled tomato & peri peri mayo",
      note: "Add wrap $2.00",
      price: 10.9
    },
    {
      name: "The Boss Roll",
      desc: "Bacon, egg, spinach, feta, avocado & peri peri mayo",
      note: "Add wrap $2.00",
      price: 11.9
    },
    {
      name: "Johnny Princess Roll",
      desc:
        "Bacon, egg, spinach, avocado, red onion, tomato, Old English cheese, hash brown & hollandaise sauce",
      note: "Add wrap $2.00",
      price: 14.9
    },
    {
      name: "Bacon & Egg Sandwich / Roll",
      desc: "Sandwich or roll available",
      price: "$8.90 / $9.90"
    },
    {
      name: "Ciabatta Toast 2 pcs",
      price: 7.9
    },
    {
      name: "Fruit Toast 2 pcs",
      price: 8.9
    },
    {
      name: "Muesli & Yoghurt Bowl",
      price: 11.9
    }
  ],
  breakfastAdds: [
    { name: "Avocado", price: 3.0 },
    { name: "Bacon", price: 4.0 },
    { name: "Barossa free range egg", price: 3.5 },
    { name: "Chorizo", price: 4.0 },
    { name: "Ciabatta toast", price: 4.0 },
    { name: "Grilled mushrooms", price: 3.0 },
    { name: "Grilled tomato", price: 3.0 },
    { name: "Hash brown", price: 3.0 }
  ],
  sandwichBar: [
    {
      name: "1. B.L.T.",
      desc: "Bacon, lettuce, tomato & mayo",
      price: 11.9
    },
    {
      name: "2. Meatlovers",
      desc: "Chicken, bacon, salami, cheese, onion & BBQ sauce",
      price: 11.9
    },
    {
      name: "3. Mediterranean",
      desc: "Salami, roasted capsicum, feta & olives",
      price: 10.9
    },
    {
      name: "4. Chicken Combo",
      desc: "Chicken or chicken tenders, bacon, cheese, tomato, lettuce & mayo",
      price: 11.9
    },
    {
      name: "5. Cajun Chicken",
      desc: "Chicken, avocado, roasted capsicum, spinach & peri peri",
      price: 10.9
    },
    {
      name: "6. Sweet Chilli Chicken",
      desc: "Chicken, cheese, avocado, tomato, lettuce & mayo",
      price: 10.9
    },
    {
      name: "7. Vego",
      desc: "Cheese, avocado, spinach & roast vegetables",
      price: 10.9
    }
  ],
  salads: [
    {
      name: "Chicken Caesar Salad",
      desc:
        "Chicken, bacon, egg, olives, feta, cherry tomatoes, cucumber, carrot, onion, lettuce, capsicum with Caesar dressing",
      price: 16.9
    },
    {
      name: "Tuna Bean Salad",
      desc:
        "Tuna, mixed beans, red onion, cherry tomatoes, cucumber, onion, lettuce with dressing",
      price: 13.9
    }
  ],
  myoProteins: [
    { name: "Bacon", price: 7.0 },
    { name: "Cheese", price: 6.0 },
    { name: "Curried egg", price: 7.0 },
    { name: "Egg", price: 6.5 },
    { name: "Roast beef", price: 7.0 },
    { name: "Roast chicken", price: 7.0 },
    { name: "Salami", price: 7.0 },
    { name: "Tuna", price: 6.5 },
    { name: "Turkey", price: 7.0 }
  ],
  myoExtras: [
    { name: "Avocado", price: 1.0 },
    { name: "Bacon", price: 3.0 },
    { name: "Beetroot", price: 0.5 },
    { name: "Capsicum", price: 0.5 },
    { name: "Carrot", price: 0.5 },
    { name: "Cheese", price: 0.5 },
    { name: "Old English cheese", price: 0.8 },
    { name: "Cucumber", price: 0.5 },
    { name: "Egg", price: 2.0 },
    { name: "Feta", price: 0.8 },
    { name: "Gherkin", price: 0.5 },
    { name: "Jalapeños", price: 0.5 },
    { name: "Lettuce", price: 0.5 },
    { name: "Meats", price: 2.0 },
    { name: "Olives", price: 0.8 },
    { name: "Onion", price: 0.5 },
    { name: "Pickled onion", price: 0.5 },
    { name: "Roast capsicum", price: 0.8 },
    { name: "Roast eggplant", price: 0.8 },
    { name: "Roast mushroom", price: 0.8 },
    { name: "Roast pumpkin", price: 0.8 },
    { name: "Spinach", price: 0.8 },
    { name: "Sun-dried tomato", price: 0.8 },
    { name: "Tomato", price: 0.5 }
  ],
  spreads: [
    { name: "Cranberry", price: 0.5 },
    { name: "Mustard pickles", price: 0.5 },
    { name: "Aioli", price: 0.2 },
    { name: "BBQ", price: 0.2 },
    { name: "Mayo", price: 0.2 },
    { name: "Mustard", price: 0.2 },
    { name: "Peri peri", price: 0.2 },
    { name: "Ranch", price: 0.2 },
    { name: "Caesar", price: 0.2 },
    { name: "Sriracha", price: 0.2 },
    { name: "Sweet chilli", price: 0.2 },
    { name: "Tomato", price: 0.2 },
    { name: "HP", price: 0.2 }
  ],
  hotFoods: [
    {
      name: "Hot Dogs",
      desc: "Plain",
      price: 8.0
    },
    {
      name: "Hot Dogs",
      desc: "Chilli",
      price: 10.0
    },
    {
      name: "Hot Dogs",
      desc: "Lot",
      price: 10.5
    },
    {
      name: "Beef Burger",
      desc: "Add chips $5.00",
      price: 15.9
    },
    {
      name: "Steak Sandwich",
      desc: "Add chips $5.00",
      price: 15.9
    },
    {
      name: "Chicken Schnitzel Burger",
      desc: "Add chips $5.00",
      price: 15.9
    },
    {
      name: "D.T. Chicken Schnitzel Burger",
      desc: "Add chips $5.00",
      price: 16.9
    },
    {
      name: "Vego Burger",
      desc: "Add chips $5.00",
      price: 14.9
    },
    {
      name: "Cup of Chips",
      price: 5.0
    },
    {
      name: "Bag / Bowl of Chips",
      price: 7.5
    },
    {
      name: "Gravy",
      price: 3.0
    }
  ],
  drinks: [
    {
      name: "Milkshakes",
      desc: "Chocolate / banana / strawberry / vanilla / caramel",
      price: 8.5
    },
    {
      name: "Thickshakes",
      desc: "Chocolate / banana / strawberry / vanilla / caramel",
      price: 9.5
    },
    {
      name: "Deluxe Milkshakes",
      desc: "Snickers / banana choc chip",
      price: 9.0
    },
    {
      name: "Deluxe Thickshakes",
      desc: "Snickers / banana choc chip",
      price: 10.0
    },
    {
      name: "Home-made Iced Coffee",
      desc: "With cream add $0.50",
      price: 8.5
    },
    {
      name: "Home-made Iced Chocolate",
      desc: "With cream add $0.50",
      price: 8.5
    }
  ],
  smoothies: [
    {
      name: "Ruga’s Special",
      desc: "Banana, berries, oats, yoghurt & milk",
      price: 11.0
    },
    {
      name: "Banana & Mango",
      desc: "Banana, mango, mango nectar & yoghurt",
      price: 11.0
    },
    {
      name: "Apple Berry",
      desc: "Mixed berries, apple juice & yoghurt",
      price: 11.0
    }
  ],
  juices: [
    {
      name: "Pink Lady",
      desc: "Apple, watermelon, strawberries & mixed berries",
      price: 10.0
    },
    {
      name: "Gone Troppo",
      desc: "Banana, pineapple, orange & mango",
      price: 10.0
    },
    {
      name: "Kick Start",
      desc: "Apple, orange, kiwi fruit & carrot",
      price: 10.0
    }
  ],
  coffee: [
    { name: "Ristretto", price: "$4.70" },
    { name: "Short Black", price: "$4.70" },
    { name: "Macchiato", price: "$4.70" },
    { name: "Affogato", price: "$5.20" },
    { name: "Piccolo", price: "$5.00" },
    { name: "Long Black", price: "$5.00 / $5.50 / $6.00" },
    { name: "Flat White", price: "$5.50 / $6.00 / $6.50" },
    { name: "Latte", price: "$5.50 / $6.00 / $6.50" },
    { name: "Cappuccino", price: "$5.50 / $6.00 / $6.50" },
    { name: "Mocha", price: "$6.00 / $6.50 / $7.00" },
    { name: "Hot Chocolate", price: "$5.50 / $6.00 / $7.00" },
    { name: "Dirty Chai", price: "$6.00 / $6.50 / $7.00" },
    { name: "Chai", price: "$5.50 / $6.00 / $6.50" }
  ],
  coffeeAdds: [
    { name: "Extra shot", price: "Add $0.70" },
    { name: "Single origin", price: "Add $1.00" },
    { name: "Decaf", price: "Add $1.00" },
    { name: "Lactose free / almond / oat / soy", price: "Add $0.70" },
    { name: "Syrups caramel / hazelnut / vanilla", price: "Add $0.70" }
  ],
  tea: [
    { name: "English Breakfast", price: "$4.50 / $5.00 / $5.50" },
    { name: "Sencha Green Tea", price: "$4.50 / $5.00 / $5.50" }
  ]
};

const quickLinks = [
  { id: "breakfast", label: "Breakfast" },
  { id: "sandwich-bar", label: "Sandwiches" },
  { id: "hot-foods", label: "Hot Foods" },
  { id: "drinks", label: "Drinks" },
  { id: "coffee", label: "Coffee" }
];

function formatPrice(price) {
  return typeof price === "number" ? `$${price.toFixed(2)}` : price;
}

function List({ items }) {
  return (
    <ul className="menu-table">
      {items.map((item, index) => (
        <li className="menu-row" key={`${item.name}-${index}`}>
          <div className="menu-row__main">
            <span className="menu-row__name">{item.name}</span>
            {item.desc ? <span className="menu-row__desc">{item.desc}</span> : null}
            {item.note ? <span className="menu-row__note">{item.note}</span> : null}
          </div>
          <div className="menu-row__price">{formatPrice(item.price)}</div>
        </li>
      ))}
    </ul>
  );
}

function Section({ id, title, note, items, wide = false }) {
  if (!items.length) return null;

  return (
    <section id={id} className={`menu-section${wide ? " menu-section--wide" : ""}`}>
      <div className="menu-section__head">
        <h2 className="menu-section__title">{title}</h2>
        {note ? <p className="menu-section__note">{note}</p> : null}
      </div>
      <List items={items} />
    </section>
  );
}

export default function Menu() {
  return (
    <main className="menu">
      <header className="menu-hero">
        <h1>Our Menu</h1>
        <p>Breakfast, sandwiches, hot foods, drinks and coffee.</p>

        <div className="menu-tools">
          <div className="menu-quicklinks">
            {quickLinks.map((link) => (
              <a key={link.id} href={`#${link.id}`} className="menu-quicklinks__btn">
                {link.label}
              </a>
            ))}
          </div>
        </div>
      </header>

      <div className="menu-layout">
        <Section id="breakfast" title="Breakfast" items={menu.breakfast} wide />
        <Section title="Add" items={menu.breakfastAdds} />

        <Section
          id="sandwich-bar"
          title="Sandwich Bar"
          note="Choice of white or wholemeal bread. Wrap, focaccia or white roll add $2.00. Toasting add $0.50."
          items={menu.sandwichBar}
          wide
        />

        <Section title="Salads" items={menu.salads} />

        <Section
          title="Make Your Own Sandwich"
          note="Choice of white or wholemeal bread. Wrap, focaccia or white roll add $2.00. Toasting add $0.50."
          items={menu.myoProteins}
          wide
        />

        <section className="menu-section">
          <div className="menu-section__head menu-section__head--sub">
            <h3 className="menu-section__subtitle">Choose Your Extras</h3>
          </div>
          <List items={menu.myoExtras} />
        </section>

        <section className="menu-section">
          <div className="menu-section__head menu-section__head--sub">
            <h3 className="menu-section__subtitle">Choice of Spreads / Dressings</h3>
          </div>
          <List items={menu.spreads} />
        </section>

        <Section id="hot-foods" title="Hot Foods" items={menu.hotFoods} wide />
        <Section id="drinks" title="Drinks" items={menu.drinks} />
        <Section title="Smoothies" items={menu.smoothies} />
        <Section title="Fresh Juices" items={menu.juices} />

        <section id="coffee" className="menu-section menu-section--wide">
          <div className="menu-section__head">
            <h2 className="menu-section__title">Coffee</h2>
            <p className="menu-section__note">Small / Medium / Large where applicable.</p>
          </div>
          <List items={menu.coffee} />

          <div className="menu-section__head menu-section__head--sub">
            <h3 className="menu-section__subtitle">Coffee Add-ons</h3>
          </div>
          <List items={menu.coffeeAdds} />
        </section>

        <Section title="Tea" items={menu.tea} />
      </div>

      <span className="menu-foot">
        Ruga&apos;s Cafe. No substitutes. Public holiday surcharge applies.
      </span>
    </main>
  );
}